module.exports = __webpack_public_path__ + "static/b341f4e4b2d023e5a48204ffbd0768d60d75323b2a3951035aba22ecec979986-438140c11aaf0f76c9e12f9f6c0b57cf.png";